import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
  Box,
  AppBar,
} from "@mui/material";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import SchoolIcon from "@mui/icons-material/School";
import RememberMeIcon from "@mui/icons-material/RememberMe";
import HomeIcon from "@mui/icons-material/Home";
import ChecklistIcon from "@mui/icons-material/Checklist";
import NavList from "./NavList";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import Toolbar from "@mui/material/Toolbar";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DuoIcon from "@mui/icons-material/Duo";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SettingsIcon from "@mui/icons-material/Settings";

import { Link } from "react-router-dom";

//This is the function that will output the image based on the text
function OutputImage(Image) {
  if (Image === "RememberMeIcon") {
    return <RememberMeIcon />;
  } else if (Image === "SchoolIcon") {
    return <SchoolIcon />;
  } else if (Image === "HomeIcon") {
    return <HomeIcon />;
  } else if (Image === "ChecklistIcon") {
    return <ChecklistIcon />;
  } else if (Image === "ShoppingCartIcon") {
    return <ShoppingCartIcon />;
  } else if (Image === "ReceiptLongIcon") {
    return <ReceiptLongIcon />;
  } else if (Image === "DuoIcon") {
    return <DuoIcon />;
  } else if (Image === "SettingsIcon") {
    return <SettingsIcon />;
  } else if (Image === "PsychologyIcon") {
    return <PsychologyIcon />;
  } else {
    return <FmdBadIcon />;
  }
}

function NavigationDrawer({ isOpen, toggleDrawer, setIsOpen, screenWidth }) {
  //This is the state of the drawers dropdowns
  const [open, setOpen] = useState({});
  //This is the function that will handle the click of the dropdown
  const handleClick = (item) => {
    setOpen({ ...open, [item]: !open[item] });
  };

  //This is the list of items that will be displayed in the drawer
  const list = () => (
    <div role="presentation" onKeyDown={toggleDrawer(false)}>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "10px",
        }}
      >
        <img
          src="https://cdn.shopify.com/s/files/1/0987/2970/files/InvestIN_Logo.jpg?v=1631624274" // Replace with your image path
          alt="Navigation"
          style={{
            width: "40px", // Adjust size as needed
            height: "40px", // Adjust size as needed
            borderRadius: "50%", // Makes the image round
            marginRight: "10px", // Adds some space between the image and the text
          }}
        />
        <Typography
          variant="h6"
          component="div"
          style={{
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          Navigation
        </Typography>
      </Box>
      <List>
        <List>
          {NavList.map((Item, index) => (
            <div key={index}>
              <ListItem
                button
                onClick={() => handleClick(Item.text)}
                key={index}
              >
                <ListItemIcon>{OutputImage(Item.Icon)}</ListItemIcon>
                <ListItemText primary={Item.text} />
                {open[Item.text] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open[Item.text]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* Subcategories for Inbox here */}
                  {Item.children.map((child, index) => {
                    return (
                      <div key={index}>
                        <ListItem
                          button
                          key={index}
                          component={Link}
                          to={`/${child.Path}`}
                          onClick={() => setIsOpen(false)}
                          target={child.NewTab ? "_blank" : ""}
                        >
                          <ListItemText inset primary={child.Name} />
                        </ListItem>
                      </div>
                    );
                  })}
                  {/* Add more subcategories as needed */}
                </List>
              </Collapse>
            </div>
          ))}
        </List>
      </List>
    </div>
  );

  //This is the return statement that will display the drawer
  return screenWidth === "Small" ? (
    <Drawer anchor="left" open={isOpen} onClose={toggleDrawer(false)}>
      {list()}
    </Drawer>
  ) : (
    <Drawer anchor="left" open={isOpen} onClose={toggleDrawer(false)}>
      {list()}
    </Drawer>
  );
}

export default NavigationDrawer;
